import { FieldErrors } from 'react-hook-form';

export function getFirstError(errors: FieldErrors) {
  return errors ? (Object.values(errors)[0]?.message as string) : undefined;
}
